import { useEffect } from 'react';
import { AppRouter } from './router';
import { Toaster } from './components/ui/toaster';
import { TooltipProvider } from './components/ui/tooltip';
import { useAuthStore } from './features/auth/store/auth-store';
import { useThemeStore } from './stores/theme-store';
import { mostrarAvisoPendienteDeSoporte } from './features/auth/soporte-vencido';

function App() {
  const checkAuth = useAuthStore((state) => state.checkAuth);
  const initTheme = useThemeStore((state) => state.initTheme);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    initTheme();
  }, [initTheme]);

  // La sesión de soporte venció en la carga anterior: el panel dice por qué (una sola vez).
  useEffect(() => {
    mostrarAvisoPendienteDeSoporte();
  }, []);

  return (
    <TooltipProvider delayDuration={300}>
      <AppRouter />
      <Toaster />
    </TooltipProvider>
  );
}

export default App;
